import { render, staticRenderFns } from "./BlackPackagesField.vue?vue&type=template&id=afe26742&"
import script from "./BlackPackagesField.vue?vue&type=script&lang=js&"
export * from "./BlackPackagesField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports